// @ts-nocheck
/* Pack Quantity Selector — PDP V2
   Clicking a pack pill (1/2/3 Pack) sets the product form's quantity input
   to that number for the currently selected variant. No product switching,
   no pricing math — the add-to-cart form reads the live quantity on submit.

   Multi-pack rule: subscriptions apply to 1 Pack ONLY.
     • 1 Pack  → the Seal "Subscribe & Save / One Time" box is shown and
                 defaults to Subscribe & Save (its usual behaviour).
     • 2/3 Pack → the whole subscription box is HIDDEN, the form is switched
                 to One Time (so it never subscribes), and the Add to Bag
                 price shows the pack TOTAL (unit one-time price × qty).

   The theme's own Add-to-Bag price writer (snippets/add-to-cart-button.liquid)
   always shows the *unit* price of the selected Seal card and re-asserts it via
   a MutationObserver + timers. So for a multi-pack we write the total and defend
   it with our own observer until the user goes back to 1 Pack. */
(function () {
  'use strict';

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // Read the native one-time card's "Want to save X%? Switch to Subscription"
  // sub-label so the custom multi-pack row can show the same TEXT (non-clickable).
  // Falls back to constructing it from the subscribe card's discount %.
  function getSwitchToSubLabel(target) {
    if (!target) return '';
    var otCard = target.querySelector(
      '.sls-option-container:not([data-selling-plan-group])'
    );
    if (otCard) {
      var nodes = otCard.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var t = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim();
        if (
          t &&
          /switch to subscri/i.test(t) &&
          t.length < 80 &&
          !/[$£€]/.test(t) &&
          !/one\s*time/i.test(t)
        ) {
          return t;
        }
      }
    }
    var subCard = target.querySelector(
      '.sls-option-container[data-selling-plan-group]'
    );
    if (subCard) {
      var m = (subCard.textContent || '').match(/(\d{1,2})\s*%/);
      if (m) return 'Want to save ' + m[1] + '%? Switch to Subscription';
    }
    return '';
  }

  function findScope(selectorEl) {
    return (
      selectorEl.closest('.product-details-column') ||
      selectorEl.closest('.product-information__wrapper') ||
      selectorEl.closest('.pdp-v2') ||
      document
    );
  }

  function findQtyInput(selectorEl) {
    // The pills live in their own block, a sibling of Buy buttons. Scope up to
    // the product column, then find the add-to-cart form's quantity input.
    var scope = findScope(selectorEl);
    var form =
      scope.querySelector('.buy-buttons-block form[data-type="add-to-cart-form"]') ||
      scope.querySelector('form[data-type="add-to-cart-form"]') ||
      scope.querySelector('.buy-buttons-block form') ||
      scope.querySelector('form');
    return form ? form.querySelector('input[name="quantity"]') : null;
  }

  function applyQty(input, qty) {
    if (!input || !(qty > 0)) return;
    input.value = qty;
    // notify any listeners / the quantity component (harmless if none)
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---- Seal subscription widget helpers -------------------------------- */

  function findSubWidget(selectorEl) {
    return findScope(selectorEl).querySelector('.sealsubs-target-element');
  }

  // Activate one Seal option card and sync its radio so Seal updates the form's
  // selling_plan (subscribe = a plan id, one time = empty).
  function selectSealOption(containers, chosen) {
    if (!chosen) return;
    containers.forEach(function (b) {
      var on = b === chosen;
      b.classList.toggle('sls-active', on);
      var inp = b.querySelector('input.sls-option');
      if (inp) inp.checked = on;
      var ariaRadio = b.querySelector('[role="radio"]');
      if (ariaRadio) ariaRadio.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var chosenInp = chosen.querySelector('input.sls-option');
    if (chosenInp) {
      chosenInp.dispatchEvent(new Event('change', { bubbles: true }));
      chosenInp.dispatchEvent(new Event('input', { bubbles: true }));
      chosenInp.click();
    }
  }

  // "$65.00" / "$1,299" → { prefix: "$", num: 65 }
  function parsePrice(text) {
    if (!text) return null;
    var m = String(text).match(/^(\D*)(\d[\d,]*(?:\.\d+)?)(.*)$/);
    if (!m) return null;
    var num = parseFloat(m[2].replace(/,/g, ''));
    if (isNaN(num)) return null;
    return { prefix: m[1] || '$', num: num };
  }

  // Read the One Time card's unit price (the card WITHOUT a selling-plan group).
  function readOneTimeUnit(target) {
    var card = target.querySelector(
      '.sls-option-container:not([data-selling-plan-group])'
    );
    if (!card) return null;
    var node =
      card.querySelector('.sls-one-time-price .sls-price .money') ||
      card.querySelector('.sls-one-time-price .money') ||
      card.querySelector('.sls-price-container .money') ||
      Array.prototype.slice
        .call(card.querySelectorAll('.money'))
        .filter(function (el) {
          return !el.closest('.sls-original-price');
        })[0];
    return node ? parsePrice(node.textContent) : null;
  }

  /* ---- Add to Bag price (mirrors snippets/add-to-cart-button.liquid) ---- */

  function eachButtonPriceEls(cb) {
    document
      .querySelectorAll('.add-to-cart-text__content')
      .forEach(function (content) {
        var wrap = content.querySelector('.custom-atc-price-wrap');
        if (!wrap) {
          wrap = document.createElement('span');
          wrap.className = 'custom-atc-price-wrap';
          wrap.style.cssText =
            'display:inline-flex;align-items:center;gap:4px;margin-left:6px;';
          wrap.innerHTML =
            '<span class="custom-atc-strike-price" style="text-decoration:line-through;margin-right:4px;display:none;"></span>' +
            '<span class="atc-price"></span>';
          content.appendChild(document.createTextNode(' '));
          content.appendChild(wrap);
        }
        cb(
          wrap.querySelector('.atc-price'),
          wrap.querySelector('.custom-atc-strike-price')
        );
      });
  }

  function writeButtonTotal(text) {
    eachButtonPriceEls(function (priceEl, strikeEl) {
      if (priceEl && priceEl.textContent !== text) priceEl.textContent = text;
      if (strikeEl) {
        strikeEl.textContent = '';
        strikeEl.style.display = 'none';
      }
    });
  }

  // Keep the pack total on the button even though the theme's price writer keeps
  // trying to reset it to the unit price.
  var desiredTotal = '';
  var enforceOn = false;
  var atcObserver = null;

  function startEnforce(text) {
    desiredTotal = text;
    enforceOn = true;
    if (!atcObserver) {
      atcObserver = new MutationObserver(function () {
        if (!enforceOn || !desiredTotal) return;
        var mismatch = false;
        document
          .querySelectorAll('.add-to-cart-text__content .atc-price')
          .forEach(function (el) {
            if (el.textContent !== desiredTotal) mismatch = true;
          });
        if (mismatch) writeButtonTotal(desiredTotal);
      });
    }
    writeButtonTotal(text);
    document
      .querySelectorAll('.add-to-cart-text__content')
      .forEach(function (c) {
        atcObserver.observe(c, {
          subtree: true,
          childList: true,
          characterData: true
        });
      });
  }

  function stopEnforce() {
    enforceOn = false;
    desiredTotal = '';
    if (atcObserver) atcObserver.disconnect();
  }

  /* ---- One Time Purchase row (2/3 Pack) -------------------------------- */
  // On a multi-pack the whole Seal box is hidden; render an explicit
  // "One Time Purchase" row (the pack TOTAL) so the buy box isn't left with an
  // empty gap. Reuses the bundle selector's .bundle-custom-subs markup + CSS.

  function findForm(selectorEl) {
    var scope = findScope(selectorEl);
    return (
      scope.querySelector('.buy-buttons-block form[data-type="add-to-cart-form"]') ||
      scope.querySelector('.buy-buttons-block form') ||
      scope.querySelector('form')
    );
  }

  function renderOneTimeRow(selectorEl, totalText, subLabel) {
    var form = findForm(selectorEl);
    if (!form) return;
    var wrapper = form.querySelector('.bundle-custom-subs-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'bundle-custom-subs-wrapper';
      var formButtons = form.querySelector('.product-form-buttons');
      if (formButtons) form.insertBefore(wrapper, formButtons);
      else form.appendChild(wrapper);
    }
    var noteHtml = subLabel
      ? '<div class="bundle-custom-subs__note">' + escapeHtml(subLabel) + '</div>'
      : '';
    wrapper.innerHTML =
      '<div class="bundle-custom-subs">' +
        '<div class="bundle-custom-subs__option bundle-custom-subs__option--active" data-type="onetime">' +
          '<div class="bundle-custom-subs__label">' +
            '<span class="bundle-custom-subs__radio"></span>' +
            '<span class="bundle-custom-subs__title">One Time Purchase</span>' +
            '<span class="bundle-custom-subs__price-wrap">' +
              '<span class="bundle-custom-subs__price">' + (totalText || '') + '</span>' +
            '</span>' +
          '</div>' +
          noteHtml +
        '</div>' +
      '</div>';
    wrapper.style.display = '';
  }

  function hideOneTimeRow(selectorEl) {
    var form = findForm(selectorEl);
    if (!form) return;
    var wrapper = form.querySelector('.bundle-custom-subs-wrapper');
    if (wrapper) wrapper.style.display = 'none';
  }

  /* ---- Core gate ------------------------------------------------------- */

  function gate(selectorEl, retriesLeft) {
    var qty = parseInt(selectorEl.dataset.tdPackQty, 10) || 1;
    var target = findSubWidget(selectorEl);
    var subBox =
      target &&
      target.querySelector('.sls-option-container[data-selling-plan-group]');

    // No subscription widget on this product → nothing to gate. If it just
    // hasn't been built yet (Seal populates async), retry briefly.
    if (!target || !subBox) {
      if (retriesLeft > 0) {
        setTimeout(function () {
          gate(selectorEl, retriesLeft - 1);
        }, 250);
      }
      return;
    }

    var containers = target.querySelectorAll('.sls-option-container');
    var oneTime = null;
    containers.forEach(function (b) {
      if (!b.hasAttribute('data-selling-plan-group')) oneTime = oneTime || b;
    });

    if (qty > 1) {
      // Can only sell a multi-pack as a one-time bulk buy if a One Time option
      // exists; otherwise leave the widget alone (subscribe-only product).
      if (!oneTime) return;
      var unit = readOneTimeUnit(target);
      selectSealOption(containers, oneTime); // Seal clears selling_plan
      target.style.display = 'none'; // hide the whole subscription box
      var packTotal = '';
      if (unit) {
        packTotal = unit.prefix + Math.round(unit.num * qty);
        startEnforce(packTotal);
      }
      // Show an explicit "One Time Purchase" row (pack total) in place of the
      // hidden subscription box, so 2/3 Pack isn't left with an empty gap.
      renderOneTimeRow(selectorEl, packTotal, getSwitchToSubLabel(target));
    } else {
      // 1 Pack — show the box, default back to Subscribe & Save, and hand the
      // Add to Bag price back to the theme's own writer.
      stopEnforce();
      target.style.display = '';
      selectSealOption(containers, subBox);
      hideOneTimeRow(selectorEl);
    }
  }

  /* ---- Pills ----------------------------------------------------------- */

  function initSelector(selectorEl) {
    if (selectorEl.dataset.tdPackInit === '1') return;
    selectorEl.dataset.tdPackInit = '1';

    var options = Array.prototype.slice.call(
      selectorEl.querySelectorAll('.td-pack-option')
    );
    if (!options.length) return;

    function select(opt) {
      options.forEach(function (o) {
        var on = o === opt;
        o.classList.toggle('td-pack-option--selected', on);
        var r = o.querySelector('.td-pack-option__radio');
        if (r) r.checked = on;
      });
      var radio = opt.querySelector('.td-pack-option__radio');
      var qty = radio ? parseInt(radio.dataset.qty, 10) : 1;
      selectorEl.dataset.tdPackQty = qty;
      applyQty(findQtyInput(selectorEl), qty);
      gate(selectorEl, 8);
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        select(opt);
      });
    });

    // Apply the default (1 Pack / first) selection's qty on load.
    var pre =
      selectorEl.querySelector('.td-pack-option--selected') || options[0];
    if (pre) {
      var r = pre.querySelector('.td-pack-option__radio');
      var qty = r ? parseInt(r.dataset.qty, 10) : 1;
      selectorEl.dataset.tdPackQty = qty;
      applyQty(findQtyInput(selectorEl), qty);
      gate(selectorEl, 20);
    }
  }

  function init(root) {
    (root || document)
      .querySelectorAll('.td-pack-selector')
      .forEach(initSelector);
  }

  function reapplyAll() {
    document.querySelectorAll('.td-pack-selector').forEach(function (sel) {
      gate(sel, 4);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor re-render support
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // Seal builds its Subscribe & Save / One Time cards asynchronously — re-apply
  // the pack gating once those cards exist (and if a variant swap rebuilds it).
  document.addEventListener('sealsubs:subscription_widget_created', function () {
    reapplyAll();
  });
})();
